//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import moment from 'moment';

var now = moment();

export default {
    props: ['inapplicant'],
    data: function data() {
        return {
            applicant: this.inapplicant,
            selectedRow: false,
            mod: false,
            filterKey: '',
            add: false,
            override: false,
            amount: 0.00,
            overrideAmount: 0.00,
            postDate: now.format('MM-DD-YYYY'),
            dueDate: now.format('MM-DD-YYYY'),
            transactions: [],
            payments: [],
            loading: true,
            balance: 0
        };
    },

    watch: {
        inapplicant: function inapplicant(newData, oldData) {

            this.applicant = newData;

            this.getLedger();
        }
    },
    created: function created() {
        Event.$on('refresh-applicant-ledger', this.getLedger);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-applicant-ledger');
    },
    mounted: function mounted() {
        this.getLedger();
    },

    methods: {
        editTransaction: function editTransaction(transaction) {
            Event.$emit('edit-gl-wizard', transaction);
        },
        getLedger: function getLedger() {
            var _this = this;

            var $el = this;

            if (this.applicant) {

                $el.loading = true;

                axios.post('/prototype/applicant/ledger/balance', {
                    id: $el.applicant.id
                }).then(function (response) {

                    _this.balance = response.data;
                });

                axios.post('/prototype/applicant/ledger', {
                    id: $el.applicant.id
                }).then(function (response) {

                    if (response.data) {

                        $el.transactions = response.data.transactions;

                        if ($el.transactions) {

                            $el.transactions.map(function (trans) {
                                return trans['type'] = 'transaction';
                            });
                        }

                        $el.payments = response.data.payments;

                        if ($el.payments) {

                            $el.payments.map(function (payment) {
                                return payment['type'] = 'payment';
                            });
                        }
                    }

                    $el.loading = false;
                });
            }
        },
        pastDue: function pastDue(due) {
            return moment(due).diff(moment()) <= 0 ? true : false;
        }
    },
    computed: {

        filteredData: function filteredData() {

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.transactions.concat(this.payments);

            data.sort(function (a, b) {
                if (new Date(a.created_at).getTime() > new Date(b.created_at).getTime()) return 1;
                if (new Date(a.created_at).getTime() < new Date(b.created_at).getTime()) return -1;
                return 0;
            });

            data.map(function (item, idx) {
                if (item.type == 'transaction') {
                    var amount = 0;
                    if (item['has_override']) {
                        amount = Number(item['override_amount']);
                    } else {
                        amount = Number(item['true_amount']);
                    }
                    if (idx === 0) {
                        item['lineBalance'] = amount;
                    } else {
                        item['lineBalance'] = Number(data[idx - 1]['lineBalance']) + Number(amount);
                    }
                }
                if (item.type == 'payment') {
                    if (idx === 0) {
                        item['lineBalance'] = Number(item.amount);
                    } else {
                        item['lineBalance'] = Number(data[idx - 1]['lineBalance']) - Number(item.amount);
                        return item['lineBalance'];
                    }
                }
            });

            data.sort(function (a, b) {
                if (a.created_at != b.created_at) {
                    if (new Date(a.created_at).getTime() > new Date(b.created_at).getTime()) return -1;
                    if (new Date(a.created_at).getTime() < new Date(b.created_at).getTime()) return 1;
                    return 0;
                }
                return b.id - a.id;
            });

            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        }

    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantLedger.vue
// module id = /o/C
// module chunks = 0 1